/** vendor */
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

/** lib */
import Loading from '../UI/Loading'
import Pagination from '../UI/Pagination'

/** state */
import { getCommunityRecipes } from '../../actions/recipe.actions'

/** components */
import RecipeListItem from './RecipeListItem'
import AllergenDialog from '../Dialogs/AllergenDialog'

export default function CommunityRecipeList() {
    const dispatch = useDispatch()

    const communityRecipes = useSelector(state => state?.community_recipes?.data)    
    const pagination = useSelector(state => state?.community_recipes)
    
    const [loading, setLoading] = useState(false)
    const [showAllergens, setShowAllergens] = useState(false)
    const [allergenDialogContent, setAllergenDialogContent] = useState([])
    
    const init = async () => {
        setLoading(true)

        try {
            await dispatch(getCommunityRecipes())
            setLoading(false)
        } catch (error) {
            console.error(error)
            setLoading(false)
        }
    }

    useEffect(() => {
        init()
    }, [])

    useEffect(() => {
        console.warn('communityRecipes', communityRecipes)
    }, [communityRecipes])

    const toggleAllergens = e => { 
        setShowAllergens(!showAllergens) 
    }
    
    const handleOnOpenAllergenDialog = (allergens) => {
        setAllergenDialogContent(allergens)
        setShowAllergens(true)
    }

    const handleOnPaginate = async (pageToRequest) => {
        setLoading(true)

        try {
            await dispatch(getCommunityRecipes(pageToRequest))
            setLoading(false)
        } catch (error) {
            setLoading(false)
        }
    }

    return (
        <div className="w-full">
            {
                loading  
                    ?   <div className="h-[60vh] relative pt-40">
                            <Loading />
                        </div>
                    :   <section className="antialiased">
                            <div className="flex flex-col justify-center">
                                <div>
                                    <div>
                                        { 
                                            communityRecipes 
                                                ? communityRecipes.map(
                                                    (r, i) =>  
                                                        <div key={i} className="w-full pt-2 px-2 cursor-pointer odd:bg-an_white-dark hover:bg-an_white-darker1">
                                                            <RecipeListItem 
                                                                handleOnOpenAllergenDialog={handleOnOpenAllergenDialog} 
                                                                recipe={r} 
                                                                key={i} 
                                                            />
                                                        </div>
                                                    )
                                                : <div className="text-center">nich.</div> 
                                        } 
                                    </div>
                                </div>
                            </div>
                        </section>
            }

            <div className="fixed h-[42px] bottom-4 left-0 p-2 w-full flex align-middle items-center justify-center">
                <Pagination
                    onPaginate={handleOnPaginate}
                    pagination={pagination} 
                /> 
            </div>

            <AllergenDialog 
                showDialog={showAllergens} 
                onCancel={toggleAllergens} 
                allergens={allergenDialogContent}  
            />
        </div>
    )
}
